import * as React from "react";
import { PrimaryButton, IButtonProps } from "office-ui-fabric-react";

const SaveBtn = props => {
  const isDisabled = 
    Office.context.mailbox.item.attachments.length === 0 ||
    (props.selectedAttachments.length > 0 && !props.selectedAttachments.some(attachment => attachment.isChecked));

  return (
    <div className="ms-Grid" dir="ltr">
      <div
        style={{
          height: 60,
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%"
        }}
      >
        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
            style={{ paddingRight: 17, paddingLeft: 17 }}
          >
            <PrimaryButton
              className="saveBtn"
              primary={true}
              data-automation-id="test"
              disabled={isDisabled}
              text="Save to SimpleLegal"
              onClick={props.saveAttachments}
              style={{
                backgroundColor: "#0E3A6E",
                fontFamily: "Lato",
                fontWeight: "normal",
                fontSize: 16,
                height: 35,
                width: "100%"
              }}
              onRenderText={onRenderBtnText}
            />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
            style={{ textAlign: "center" }}
          >
            <span
              style={{
                color: "black",
                textAlign: "center",
                marginTop: 10,
                fontFamily: "Lato",
                fontSize: 12,
                fontWeight: "normal",
                lineHeight: "25px"
              }}
            >
              {`© 2019 SimpleLegal, Inc.`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
const onRenderBtnText = (_props: IButtonProps): JSX.Element => {
  return (
    <div
      style={{
        textAlign: "center",
        fontFamily: "Lato",
        fontSize: 16,
        fontWeight: "normal",
        paddingBottom: 2
      }}
    >
      Save to SimpleLegal
    </div>
  );
};
export default SaveBtn;
